import { render, staticRenderFns } from "./AtomArrowButtonSlider.vue?vue&type=template&id=535b8a08&"
import script from "./AtomArrowButtonSlider.vue?vue&type=script&lang=js&"
export * from "./AtomArrowButtonSlider.vue?vue&type=script&lang=js&"
import style0 from "./AtomArrowButtonSlider.vue?vue&type=style&index=0&id=535b8a08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports